/** Nature colors are shared by Budgets and Synthesis; alerts retain their own labels. */
export const NATURE_STYLES = {
  expense: {
    text: "text-amber-800 dark:text-amber-300",
    select: "border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200",
    accent: "border-l-4 border-l-amber-600 dark:border-l-amber-400",
    chartColor: "var(--color-amber-600)",
  },
  revenue: {
    text: "text-emerald-800 dark:text-emerald-300",
    select: "border-emerald-300 bg-emerald-50 text-emerald-900 dark:border-emerald-700 dark:bg-emerald-950 dark:text-emerald-200",
    accent: "border-l-4 border-l-emerald-600 dark:border-l-emerald-400",
    chartColor: "var(--color-emerald-600)",
  },
} as const;
